import { FEATURE_FLAGS_FOR_SELLER } from '@savgroup-front-common/constants';
import { useGetFeatureFlagsQuery } from '@savgroup-front-common/core/api/Authorization/useGetFeatureFlagsQuery';

import { useAuth } from '../../../login/AuthProviderContext';

interface UseHeaderActionsArgs {
  sellerId: string;
}

export const useHeaderActions = ({ sellerId }: UseHeaderActionsArgs) => {
  const isLogoutEnabled = useGetFeatureFlagsQuery({
    featureFlag: [FEATURE_FLAGS_FOR_SELLER.SELFCARE_LOGOUT],
    sellerId,
    suspense: false,
  });
  const { logout } = useAuth();

  return { isLogoutEnabled, logout };
};
